import { TFunction } from 'i18next';

export const getCardsBenefits = (t: TFunction) => {
  const benefits = t('store.productPage.cardsBenefits', {
    returnObjects: true,
  }) as Array<{ title: string; description: string }>;

  return benefits?.length
    ? benefits.map?.((benefit) => ({
        title: benefit.title,
        text: benefit.description,
      }))
    : [];
};
